module.exports = "/images/vendor/desiigner-svg/svg/ui/search.svg?0756c991e1dac44420f06daf897842f1";